// src/lib/api.js
import axios from "axios";

const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
  xsrfCookieName: 'csrftoken', 
  xsrfHeaderName: 'X-CSRFToken',
});

// localStorage / sessionStorage の両方を参照するヘルパー
function getStoredToken(key) {
  return localStorage.getItem(key) ?? sessionStorage.getItem(key) ?? null;
}

function setStoredToken(key, value) {
  // refresh が localStorage にあれば永続保存、なければ sessionStorage に保存
  if (localStorage.getItem("refresh")) {
    localStorage.setItem(key, value);
  } else {
    sessionStorage.setItem(key, value);
  }
}

// 毎リクエストで Authorization を付与
api.interceptors.request.use((config) => {
  const t = getStoredToken("access");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// 401 のとき 1 回だけリフレッシュして再試行
let refreshing = false;
let waiters = [];

async function refreshAccessToken() {
  const refresh = getStoredToken("refresh");
  if (!refresh) throw new Error("NO_REFRESH");
  const res = await axios.post("/api/auth/token/refresh/", { refresh });
  const { access } = res.data || {};
  if (!access) throw new Error("REFRESH_FAILED");
  setStoredToken("access", access);
  return access;
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error || {};
    if (!response || response.status !== 401 || config.__retried) {
      return Promise.reject(error);
    }
    try {
      if (refreshing) {
        await new Promise((r) => waiters.push(r));
      } else {
        refreshing = true;
        await refreshAccessToken();
        refreshing = false;
        waiters.forEach((r) => r());
        waiters = [];
      }
      config.__retried = true;
      const t = getStoredToken("access");
      if (t) config.headers.Authorization = `Bearer ${t}`;
      return api.request(config);
    } catch (e) {
      refreshing = false;
      waiters.forEach((r) => r());
      waiters = [];
      // リフレッシュ失敗 → 両ストレージをクリア
      ["access", "refresh"].forEach((key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      });
      return Promise.reject(error);
    }
  }
);

export default api;
